/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SigfoxDeviceValueEvaluation from './SigfoxDeviceValueEvaluation';

/**
* The SigfoxDeviceCheckRecord model module.
* @module model/SigfoxDeviceCheckRecord
* @version 2020-12-7
*/
export default class SigfoxDeviceCheckRecord {
    /**
    * Constructs a new <code>SigfoxDeviceCheckRecord</code>.
    * @alias module:model/SigfoxDeviceCheckRecord
    * @class
    * @param messages {Array.<module:model/SigfoxDeviceValueEvaluation>} 
    * @param voltage {module:model/SigfoxDeviceValueEvaluation} 
    * @param maxTemperature {module:model/SigfoxDeviceValueEvaluation} 
    * @param minTemperature {module:model/SigfoxDeviceValueEvaluation} 
    * @param rssi {module:model/SigfoxDeviceValueEvaluation} 
    */

    constructor(messages, voltage, maxTemperature, minTemperature, rssi) {
        
        
        this['messages'] = messages;
        this['voltage'] = voltage;
        this['maxTemperature'] = maxTemperature;
        this['minTemperature'] = minTemperature;
        this['rssi'] = rssi;
        
    }

    /**
    * Constructs a <code>SigfoxDeviceCheckRecord</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SigfoxDeviceCheckRecord} obj Optional instance to populate.
    * @return {module:model/SigfoxDeviceCheckRecord} The populated <code>SigfoxDeviceCheckRecord</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SigfoxDeviceCheckRecord();
                        
            
            if (data.hasOwnProperty('messages')) {
                obj['messages'] = ApiClient.convertToType(data['messages'], [SigfoxDeviceValueEvaluation]);
            }
            if (data.hasOwnProperty('voltage')) {
                obj['voltage'] = SigfoxDeviceValueEvaluation.constructFromObject(data['voltage']);
            }
            if (data.hasOwnProperty('maxTemperature')) {
                obj['maxTemperature'] = SigfoxDeviceValueEvaluation.constructFromObject(data['maxTemperature']);
            }
            if (data.hasOwnProperty('minTemperature')) {
                obj['minTemperature'] = SigfoxDeviceValueEvaluation.constructFromObject(data['minTemperature']);
            }
            if (data.hasOwnProperty('rssi')) {
                obj['rssi'] = SigfoxDeviceValueEvaluation.constructFromObject(data['rssi']);
            }
        }
        return obj;
    }

    /**
    * @member {Array.<module:model/SigfoxDeviceValueEvaluation>} messages
    */
    'messages' = undefined;
    /**
    * @member {module:model/SigfoxDeviceValueEvaluation} voltage
    */
    'voltage' = undefined;
    /**
    * @member {module:model/SigfoxDeviceValueEvaluation} maxTemperature
    */
    'maxTemperature' = undefined;
    /**
    * @member {module:model/SigfoxDeviceValueEvaluation} minTemperature
    */
    'minTemperature' = undefined;
    /**
    * @member {module:model/SigfoxDeviceValueEvaluation} rssi
    */
    'rssi' = undefined;




}
